module.exports = __webpack_public_path__ + "img/product1.c3539626.png";